import { render, staticRenderFns } from "./ReceptionStatus.vue?vue&type=template&id=ae05b3a0&scoped=true&"
import script from "./ReceptionStatus.vue?vue&type=script&lang=js&"
export * from "./ReceptionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae05b3a0",
  null
  
)

export default component.exports